<template>
  <DialogLayout class="wx-biz-message-logger"
                title="消息发送日志">
    <template v-if="rowData.sendNote">
      <AppScrollbar style="height: 100%">
        <div class="logger-main">
          <div class="content">{{rowData.sendNote}}</div>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint>
        <div>日志内容为空</div>
      </Hint>
    </template>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'WxBizMessageLogger',
  components: {
    DialogLayout,
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .wx-biz-message-logger {
    width: 420px;
    max-width: 100%;
    .logger-main {
      padding: 10px;
      .content {
        font-size: 12px;
        line-height: 200%;
        white-space: pre-wrap;
      }
    }
  }
</style>
